import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ModalModule } from 'ngx-bootstrap/modal'
import { AppCommonModule } from '../common/common.module'
import { AppCoreModule } from '../core/core.module'
import { AtLeastOneDirective } from './configuracao-integracao/configuracao-integracao-bandeira/at-least-one.directive'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoBandeiraModalEdicaoComponent } from './configuracao-integracao/configuracao-integracao-bandeira/configuracao-bandeira-modal-edicao/configuracao-bandeira-modal-edicao.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoBandeiraModalVisualizacaoComponent } from './configuracao-integracao/configuracao-integracao-bandeira/configuracao-bandeira-modal-visualizacao/configuracao-bandeira-modal-visualizacao.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoExistenteDirective } from './configuracao-integracao/configuracao-integracao-bandeira/configuracao-existente.directive'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoBandeiraComponent } from './configuracao-integracao/configuracao-integracao-bandeira/configuracao-integracao-bandeira.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoOperadoraComponent } from './configuracao-integracao/configuracao-integracao-operadora/configuracao-integracao-operadora.component'
import { ConfiguracaoIntegracaoComponent } from './configuracao-integracao/configuracao-integracao.component'
import { ConfiguracaoService } from './shared/configuracao.service'
import { LayoutService } from './shared/layout.service'

@NgModule({
    imports: [RouterModule, AppCommonModule, AppCoreModule, ModalModule.forRoot()],
    declarations: [
        ConfiguracaoIntegracaoComponent,
        ConfiguracaoIntegracaoOperadoraComponent,
        ConfiguracaoBandeiraModalEdicaoComponent,
        ConfiguracaoIntegracaoBandeiraComponent,
        ConfiguracaoBandeiraModalVisualizacaoComponent,
        ConfiguracaoExistenteDirective,
        AtLeastOneDirective,
    ],
    providers: [ConfiguracaoService, LayoutService],
    entryComponents: [
        ConfiguracaoBandeiraModalEdicaoComponent,
        ConfiguracaoBandeiraModalVisualizacaoComponent,
    ],
})
export class ConfiguracaoModule {}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao.module.ts